

import TestimonialTable from "components/Cards/Testimonial";
import React from "react";

// components



export default function Testimonial() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <TestimonialTable />
        </div>
      </div>
    </>
  );
}
